import { createApp } from 'vue'

import App from './components/PublicAuthChecker.vue'

createApp(App).mount('#publicauthchek')
